import { useState,useEffect,useRef } from "react";
import FoodDetailModal from "./foodDetailModal";
import post from '../post';
import cn from 'classnames';
import { useLocation as location2 } from "wouter";
import Loading from "../components/Loading";
import Alert from "../components/Alert";
import { VerCarrito } from "../components/Utilities";
import * as Constants from '../constants';


const getCats=(m)=>{
    let categorias={};
    Object.keys(m).forEach((menu_id)=>{
        //console.log(menu_id);
        const z=Object.keys(m[menu_id].cats);
        z.forEach((cat,idx)=>{
            if(categorias[cat]) return;
            categorias[cat]={...m[menu_id].cats[cat],cat_id:cat,orderIdx:idx};
        });
    });
    categorias=Object.keys(categorias).map(e=>categorias[e]);
    return categorias;
}
const toPesos=function(n){
    const options = { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
    };
    return Number(n).toLocaleString('en', options);  
}
const checkCollision = (rect1, rect2) => {
      if (!rect1 || !rect2) return false;
      return (
        !( rect1.bottom < rect2.top ||
            rect1.top-50 > rect2.bottom)
      );
    };


const Order = () => {
    const [menu,setMenu]=useState(false);
    const [selectedItem,setSelectedItem]=useState(false); 
    const [selectedCat,setSelectedCat]=useState(false);
    const [location, navigate] = location2();
    const [loading, setLoading] = useState(false);
    const catMenuRef=useRef(null);
    const targetDivRef=useRef([]);
    const user_id = localStorage.getItem('token');
    const [alert, setAlert] = useState({ isOpen: false });
    if (!user_id) {
        navigate('/login');
    }
    const currentOrder=JSON.parse(localStorage.getItem('currentOrder')) || {};
    if(!currentOrder || !currentOrder.sucursal_id){
        navigate('/tipoSelect');
    }
    //fetch menu from server
    useEffect(()=>{
        const getmenu=async ()=>{
            setLoading(true);
            const c= await post('getMenu',{ sucursal_id: currentOrder.sucursal_id });
            if(!c.result){
                //navigate('/');
                setAlert({ 
                    isOpen: true, 
                    title: 'Error',
                    message: 'No se pudo cargar el menú. Intenta de nuevo más tarde.',
                    onClose: () => { navigate('/'); }
                });
                return;
            }
            const c1=getCats(c.data);
            setMenu(c1);
            
            if(c1 && c1.length>0){
                setSelectedCat(c1[0].cat_id);
            }
            setLoading(false);
        };
        getmenu();  
    },[]);
    useEffect(() => {
        const handleScrollOrResize = () => {
            const fixedRect = catMenuRef.current?.getBoundingClientRect();
            ;
            targetDivRef.current.forEach((div, index) => {
                if (checkCollision(div.getBoundingClientRect(), fixedRect)) {
                    //extract data-cat from div
                    const catId = div.getAttribute('data-cat');
                    setSelectedCat(catId);
                    //scroll to the category button
                    const catButton = document.querySelector(`button[data-cat="${catId}"]`);
                    if (catButton) {
                        catButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                    }
                }
             });
        };
        window.addEventListener('scroll', handleScrollOrResize);
        window.addEventListener('resize', handleScrollOrResize);
        return ()=>{
            window.removeEventListener('scroll', handleScrollOrResize);
            window.removeEventListener('resize', handleScrollOrResize);
    }},[]);

   
    //determine which category is at top of screen
    
    return (
        <div id="webcrumbs" className="min-h-screen bg-white relative pb-16 flex flex-col items-center justify-center text-neutral-700">
            <VerCarrito hasTabNav={false} />
            <Alert isOpen={alert?.isOpen} title={alert?.title} message={alert?.message} onClose={alert?.onClose || (() => setAlert({ isOpen: false, title: '', message: '' }))} />
            <Loading isOpen={loading} />
        <div className="z-50 border-b border-neutral-200 top-0 sticky w-full max-w-3xl px-6 pt-10 pb-1 relative bg-white flex">
            <button 
                className="absolute top-4 left-4 z-10 w-10 h-10 bg-neutral-200 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
                onClick={()=>{navigate('/');}}
            >
                <span className="material-symbols-outlined text-primary-600">arrow_back</span>
            </button>
            <div className="text-neutral-700 mx-auto my-auto">Menú</div>
        </div>
        <div className="bg-white px-4 shadow-sm ">
                   
                    <div className="flex items-center justify-between mb-3 ">
                        <div className="flex items-center space-x-2">
                            {currentOrder?.tipo=='delivery'?(
                                <>                                <span className="material-symbols-outlined text-primary-600">location_on</span>
                                <div>
                                    <h2 className="text-sm font-medium text-neutral-700">Entregar a:</h2>
                                    <p className="text-sm text-neutral-600">{currentOrder?.xtra_data?.calle} {currentOrder?.xtra_data?.ext} {currentOrder?.xtra_data?.int}</p>
                                </div>
                                </>
                            ):(
                                <>
                                <span className="material-symbols-outlined text-primary-600">fastfood</span>
                                <div>
                                    <h2 className="text-sm font-medium text-neutral-700">Recoger en:</h2>
                                    <p className="text-sm text-neutral-600">
                                        {currentOrder?.xtra_data?.nombre} - {currentOrder?.xtra_data?.direccion}
                                    </p>
                                </div>
                                </>
                            )}
                            
                        </div>
                        <button className="ml-3 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors">
                            Cambiar
                        </button>
                    </div>
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Buscar..."
                            className="w-full p-3 pl-10 border border-neutral-300 rounded-full focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                        />
                        <span className="material-symbols-outlined text-neutral-500 absolute left-3 top-1/2 transform -translate-y-1/2">
                            search
                        </span>
                    </div>
                </div>
                {menu && (
               <div className="  pb-20 bg-white ">
                    
                    <div className="flex  overflow-x-auto mb-4 no-scrollbar sticky py-3 top-[60px] px-3 bg-white">
                        { Object.keys(menu).map((cat) => {
                            const n= menu[cat].cat_nombre;
                            return (
                                <button
                                    key={"cat"+cat}
                                    ref={catMenuRef}
                                    data-cat={menu[cat].cat_id}
                                    className={cn("flex-shrink-0 px-4 py-2  text-neutral-700 rounded-full mr-2 whitespace-nowrap  hover:bg-neutral-100 transition-colors ",
                                        selectedCat==menu[cat].cat_id?"bg-primary-600 text-white":""
                                    )}
                                    onClick={() => {
                                        setSelectedCat(menu[cat].cat_id);
                                        const targetDiv = document.querySelector(`div[data-cat="${menu[cat].cat_id}"]`);
                                        const yOffset = -123; // Adjust this value based on your header height
                                        if (targetDiv) {
                                            const y = targetDiv.getBoundingClientRect().top + window.scrollY + yOffset;
                                            window.scrollTo({
                                                top: y,
                                                behavior: 'smooth'
                                            });
                                        }
                                    }
                                    }
                                >
                                {n}
                                </button>
                            );
                        })}
                       
                    </div>
                    <div className="px-4" id="">
                    { Object.keys(menu).map((cat,i) => {
                        const p= menu[cat].prods;
                        return(
                            
                            <div  className="text-neutral-700" 
                                key={"cat"+cat}
                                data-cat={menu[cat].cat_id}
                                ref={(el) => (targetDivRef.current[i] = el)}
                            >
                            <h2 className="text-xl font-bold mb-4">{menu[cat].cat_nombre}</h2>
                            <div className="space-y-3 mb-8">
                            {p.map(prod => (
                                <div className="bg-white p-3 rounded-lg shadow-sm flex items-center justify-between hover:shadow-md transition-shadow duration-300"
                                    onClick={()=>{setSelectedItem(prod)}}
                                    key={"prd"+prod.id}
                                >
                                    <div className="flex items-center">
                                        <div className="w-16 h-16 rounded-lg overflow-hidden mr-3">
                                            {prod.photo?(
                                                <img
                                                    src={Constants.BASE_URL+"uploads/"+prod.photo}
                                                    alt={prod.nombre}
                                                    className="w-full h-full object-cover"
                                                    keywords="burger, double burger, fast food"
                                                />
                                            ):(
                                                <img
                                                    src="https://placehold.co/200x200/primary/white?text=No+Image"
                                                    alt="No image available"
                                                    className="w-full h-full object-cover"
                                                />
                                            )}
                                            <img
                                                src={Constants.BASE_URL+"uploads/"+prod.photo}
                                                alt="{prod.nombre}"
                                                className="w-full h-full object-cover"
                                                keywords="burger, double burger, fast food"
                                            />
                                        </div>
                                        <div>
                                            <h3 className="font-medium">{prod.nombre}</h3>
                                            <p className="text-sm text-neutral-600">${toPesos(prod.precio)}</p>
                                        </div>
                                    </div>
                                    <button className="p-2 aspect-square flex align-center bg-primary-600 text-white rounded-full hover:bg-primary-700 transition-colors">
                                        <span className="material-symbols-outlined">add</span>
                                    </button>
                                </div>
                                
                            )) }
                            </div>
                            </div>
                        ); 
                    })}
                     </div>   

                    
                    
                </div>
                )}
                <FoodDetailModal 
                    foodItem={selectedItem} 
                    onClose={() => {setSelectedItem(false)}}    
                />
            </div>
);
}

export default Order;